import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {swalError} from "../../../helpers/SweetAlertWrapper";
import Page from "../../../components/BaseComponents/Page/Page";
import {FaRegularIcon, FaSolidIcon} from "../../../components/FontAwesomeIcons";
import AppConfig from "../../../config/AppConfig";
import standardEventCover from "../../../img/coriandoli.png";
import {USER_EVENT_THEME_COLORS, USER_EVENT_THEME_FONTS, USER_EVENT_TYPE_PHOTO_ALBUM} from "../CreateEvent/CreateEventConstants";
import {UsersModulePhotoAlbumsAPI} from "../../../api/UsersModulePhotoAlbums/UsersModulePhotoAlbumsAPI";

export class UserPhotoAlbumPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            eventInfo: {},
            fetching: true
        };
        this.coverStyle = {
            minHeight: "260px",
            backgroundSize: "cover",
            backgroundPosition: "center",
            overflow: "hidden",
        };
        this.coverOverlayBaseStyle = {
            minHeight: "260px",
        };
        this.iconBoxStyle = {
            width: "38px",
            minWidth: "38px",
            height: "38px",
        };
        this.colorDotStyle = {
            width: "12px",
            height: "12px",
        };
        this.emptyBoxStyle = {
            minHeight: "220px",
        }
    }

    componentDidMount() {
        this.fetchEvent()
    }

    fetchEvent = _ => {
        this.setState({fetching: true})
        UsersModulePhotoAlbumsAPI.User.getFullUserEventInfo(this.props.photoAlbumId)
            .then(eventInfo => {
                this.setState({eventInfo: eventInfo || {}, fetching: false})
            })
            .catch(error => {
                swalError(error)
                this.setState({fetching: false})
            })
    }

    getEventInfo = _ => this.state.eventInfo || {}

    getSettings = _ => this.getEventInfo().settings || {}

    getSelectedColor = _ => {
        const color = this.getSettings().landing_primary_color;
        return color && color !== "0" ? color : USER_EVENT_THEME_COLORS[0].value;
    }

    getSelectedFont = _ => {
        const fontFamily = this.getSettings().landing_font_family;
        const fontKey = Object.keys(USER_EVENT_THEME_FONTS).find(key => {
            const font = USER_EVENT_THEME_FONTS[key];
            return font.label === fontFamily || key === fontFamily;
        });
        return USER_EVENT_THEME_FONTS[fontKey] || USER_EVENT_THEME_FONTS.roboto;
    }

    getFontFamily = _ => this.getSelectedFont().property.replace(" !important", "")

    getImageUrl = _ => {
        const imageUrl = this.getEventInfo().image_url;
        if (!imageUrl) {
            return standardEventCover;
        }
        if (imageUrl.indexOf("http") === 0) {
            return imageUrl;
        }
        return `${AppConfig.webServerUrl}${imageUrl.indexOf("/") === 0 ? imageUrl : `/${imageUrl}`}`;
    }

    getCoverStyle = _ => ({
        ...this.coverStyle,
        backgroundImage: `url(${this.getImageUrl()})`,
        fontFamily: this.getFontFamily(),
    })

    getCoverOverlayStyle = _ => ({
        ...this.coverOverlayBaseStyle,
        background: `linear-gradient(180deg, ${this.getSelectedColor()}33 0%, ${this.getSelectedColor()}dd 100%)`,
    })

    getColorDotStyle = _ => ({
        ...this.colorDotStyle,
        backgroundColor: this.getSelectedColor(),
    })

    getEventName = _ => this.getEventInfo().name || this.getEventInfo().title || "Evento"

    getEventTypeLabel = _ => this.getEventInfo().event_type === USER_EVENT_TYPE_PHOTO_ALBUM ? "Album fotografico" : "Raccolta adesioni"

    getEventTypeIcon = _ => this.getEventInfo().event_type === USER_EVENT_TYPE_PHOTO_ALBUM ? "camera" : "user-friends"

    getParsedDate = date => date ? moment(date) : null

    formatDate = date => {
        const parsedDate = this.getParsedDate(date);
        return parsedDate && parsedDate.isValid() ? parsedDate.format("DD MMMM YYYY") : null;
    }

    formatDateRange = _ => {
        const startDate = this.formatDate(this.getEventInfo().start_date);
        const endDate = this.formatDate(this.getEventInfo().end_date);
        if (startDate && endDate && startDate !== endDate) {
            return `${startDate} - ${endDate}`;
        }
        return startDate || endDate || "Data non impostata";
    }

    formatExpectedParticipants = _ => {
        const expectedParticipants = parseInt(this.getEventInfo().expected_participants, 10);
        return expectedParticipants > 0 ? expectedParticipants : "Illimitati";
    }

    formatMaxParticipantsPerReservation = _ => {
        const maxParticipants = parseInt(this.getEventInfo().max_participants_per_reservation, 10);
        return maxParticipants > 0 ? maxParticipants : "Nessun limite";
    }

    isSettingEnabled = settingName => this.getSettings()[settingName] === "1" || this.getSettings()[settingName] === 1

    renderLoading = _ => (
        <div className={"d-flex align-items-center justify-content-center text-muted"} style={this.emptyBoxStyle}>
            <i className="fa fa-spin fa-spinner"/>
        </div>
    )

    renderInfoItem = (icon, label, value) => (
        <div className={"d-flex align-items-center mb-3"}>
            <div className={"rounded bg-light d-flex align-items-center justify-content-center text-primary mr-3"} style={this.iconBoxStyle}>
                <FaSolidIcon name={icon}/>
            </div>
            <div>
                <div className={"small text-muted"}>{label}</div>
                <div className={"font-weight-bold"}>{value}</div>
            </div>
        </div>
    )

    render() {
        const eventInfo = this.getEventInfo();
        const description = eventInfo.description || "Nessuna descrizione inserita.";
        return (
            <Page
                title={this.getEventName()}
                leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                onLeftIconClick={this.props.onDismiss}
                active={true}
            >
                {
                    this.state.fetching ?
                        this.renderLoading() :
                        <div className={"container py-3"}>
                            <style>
                                {this.getSelectedFont().import}
                            </style>

                            <div className={"card border-0 shadow-sm overflow-hidden mb-3"}>
                                <div style={this.getCoverStyle()}>
                                    <div className={"d-flex flex-column justify-content-end text-white p-3"} style={this.getCoverOverlayStyle()}>
                                        <div className={"mb-2"}>
                                            <span className={"badge badge-light text-dark rounded-pill px-3 py-2"}>
                                                <FaSolidIcon name={this.getEventTypeIcon()} className={"mr-1"}/>
                                                {this.getEventTypeLabel()}
                                            </span>
                                        </div>
                                        <h4 className={"font-weight-bold mb-2"}>{this.getEventName()}</h4>
                                        <div className={"small"}>
                                            <FaRegularIcon name={"calendar"} className={"mr-1"}/>
                                            {this.formatDateRange()}
                                            {
                                                eventInfo.location_name &&
                                                <span className={"ml-2"}>
                                                    <FaSolidIcon name={"map-marker-alt"} className={"mr-1"}/>
                                                    {eventInfo.location_name}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"card border-0 shadow-sm mb-3"}>
                                <div className={"card-body"}>
                                    <h6 className={"font-weight-bold mb-2"}>Dettagli evento</h6>
                                    <div className={"text-muted"}>{description}</div>
                                </div>
                            </div>

                            <div className={"card border-0 shadow-sm mb-3"}>
                                <div className={"card-body pb-2"}>
                                    {this.renderInfoItem("calendar-alt", "Periodo", this.formatDateRange())}
                                    {this.renderInfoItem("map-marker-alt", "Luogo", eventInfo.location_name || eventInfo.location_address || "Luogo non impostato")}
                                    {this.renderInfoItem("users", "Partecipanti attesi", this.formatExpectedParticipants())}
                                    {this.renderInfoItem("user-plus", "Massimo per prenotazione", this.formatMaxParticipantsPerReservation())}
                                </div>
                            </div>

                            <div className={"card border-0 shadow-sm mb-5"}>
                                <div className={"card-body"}>
                                    <h6 className={"font-weight-bold mb-3"}>Impostazioni landing</h6>
                                    <div className={"d-flex align-items-center mb-2"}>
                                        <span className={"rounded-circle mr-2"} style={this.getColorDotStyle()}/>
                                        <span className={"text-muted"}>Colore principale</span>
                                    </div>
                                    <div className={"small text-muted"}>
                                        Nomi partecipanti: {this.isSettingEnabled("collect_all_participants_names") ? "richiesti per tutti" : "solo referente"}
                                    </div>
                                    <div className={"small text-muted"}>
                                        Intolleranze: {this.isSettingEnabled("show_intolerances") ? "visibili" : "nascoste"}
                                    </div>
                                    <div className={"small text-muted"}>
                                        Note: {this.isSettingEnabled("show_notes") ? "visibili" : "nascoste"}
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </Page>
        );
    }
}

UserPhotoAlbumPage.propTypes = {
    onDismiss: PropTypes.func,
    photoAlbumId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
